import Swal from "sweetalert2";
import { activateUser, deactivateUser } from "../apiClient";
import Resources from "../types/Resources";
import { createQueryParams } from "../common/urlUtils";

export function enable(resources: Resources, filter: any) {
    enableActivateUsers(resources, filter);
    enableDeactivateUsers(resources, filter);
}

function enableActivateUsers(resources: Resources, filter: any) {
    const buttons = document.querySelectorAll<HTMLButtonElement>("button[data-activate-user-id]");

    buttons.forEach((b) => {
        const userId = b.dataset.activateUserId;
        const userFullName = b.dataset.userFullName;

        b.addEventListener("click", async () => {
            const swalResult = await Swal.fire({
                icon: "warning",
                title: resources.get("Activate"),
                html: `
                    ${resources.get("ActivateUserConfirmation")}
                    <span class="text-nowrap fw-bold">${userFullName}</span>?
                `,
                showCancelButton: true,
                confirmButtonText: resources.get("Yes"),
                cancelButtonText: resources.get("No"),
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33"
            });

            if (swalResult.isDismissed) {
                return;
            }

            document.body.style.cursor = "wait";
            b.disabled = true;

            const activateResult = await activateUser(userId ?? "");
            if (activateResult.failed) {
                document.body.style.cursor = "default";
                b.disabled = false;

                console.error(activateResult.error);
                Swal.fire({
                    icon: "error",
                    title: resources.get("SomethingWentWrong"),
                    text: resources.get("ActivateUserError")
                });

                return;
            }

            const queryParams = filter ? createQueryParams(filter) : "";
            const updatedUrl = window.location.pathname + queryParams;

            window.location.replace(updatedUrl);
        });
    });
}

function enableDeactivateUsers(resources: Resources, filter: any) {
    const buttons = document.querySelectorAll<HTMLButtonElement>("button[data-deactivate-user-id]");

    buttons.forEach((b) => {
        const userId = b.dataset.deactivateUserId;
        const userFullName = b.dataset.userFullName;

        b.addEventListener("click", async () => {
            const swalResult = await Swal.fire({
                icon: "warning",
                title: resources.get("DeactivateUser"),
                html: `
                    ${resources.get("DeactivateUserConfirmation")}
                    <span class="text-nowrap fw-bold">${userFullName}</span>?
                `,
                showCancelButton: true,
                confirmButtonText: resources.get("Yes"),
                cancelButtonText: resources.get("No"),
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33"
            });

            if (swalResult.isDismissed) {
                return;
            }
            document.body.style.cursor = "wait";
            b.disabled = true;

            const deactivateResult = await deactivateUser(userId ?? "");
            if (deactivateResult.failed) {
                document.body.style.cursor = "default";
                b.disabled = false;

                console.error(deactivateResult.error);
                Swal.fire({
                    icon: "error",
                    title: resources.get("SomethingWentWrong"),
                    text: resources.get("DeactivateUserError")
                });

                return;
            }

            const queryParams = filter ? createQueryParams(filter) : "";
            const updatedUrl = window.location.pathname + queryParams;

            window.location.replace(updatedUrl);
        });
    });
}
